"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulletListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BulletListItem = exports.BulletListItem = function BulletListItem(_ref) {
  var direction = _ref.direction,
    image = _ref.image,
    className = _ref.className,
    children = _ref.children,
    styles = _ref.styles,
    Wrapper = _ref.Wrapper,
    namespace = _ref.namespace,
    qeId = _ref.qeId;
  var classNames = (0, _classnames2["default"])('bulletListItem', className, styles.bulletListItem, _defineProperty({}, styles.vertical, direction === 'vertical'));
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: (0, _classnames2["default"])(classNames),
    namespace: namespace,
    "data-qe-id": qeId
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames2["default"])('imageContainer', styles.imageContainer)
  }, image), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames2["default"])('contentContainer', styles.contentContainer)
  }, children));
};
BulletListItem.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  direction: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  image: _propTypes["default"].node,
  styles: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])),
  Wrapper: _propTypes["default"].node,
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
BulletListItem.defaultProps = {
  className: undefined,
  direction: 'horizontal',
  image: null,
  styles: {},
  Wrapper: 'div',
  namespace: 'bulletListItem',
  qeId: undefined
};